// Portado de /tmp/astro/src/pages/consulta-online.astro (site Astro).
import { useAgendamentoLink } from "@/lib/itv/agendamento";

const PASSOS = [
  {
    numero: "01",
    titulo: "Agende pelo WhatsApp",
    texto: "Você recebe o link da consulta e as orientações.",
  },
  {
    numero: "02",
    titulo: "Consulta por vídeo",
    texto: "Uma consulta longa, com espaço para a sua história, sintomas, hábitos e objetivos.",
  },
  {
    numero: "03",
    titulo: "Exames na sua cidade",
    texto:
      "Os exames são solicitados e você faz no laboratório de sua preferência. O acompanhamento segue a distância.",
  },
];

// URLs vindas do MENU em src/lib/itv/site.ts.
const FRENTES = [
  {
    titulo: "Emagrecimento",
    texto: "Investigação, plano e acompanhamento a distância.",
    href: "/tratamentos/emagrecimento/",
  },
  {
    titulo: "Reposição hormonal",
    texto: "Avaliação de sintomas e exames feitos na sua cidade.",
    href: "/tratamentos/saude-hormonal/",
  },
  {
    titulo: "Massa muscular e sarcopenia",
    texto: "Plano de proteína e treino com reavaliações por vídeo.",
    href: "/tratamentos/massa-muscular/",
  },
  {
    titulo: "Medicina do esporte",
    texto: "Performance e recuperação de quem treina.",
    href: "/tratamentos/medicina-do-esporte/",
  },
  {
    titulo: "Longevidade e qualidade de vida",
    texto: "O acompanhamento completo, de qualquer lugar.",
    href: "/tratamentos/longevidade/",
  },
  {
    titulo: "Avaliação 360°",
    texto: "A porta de entrada, também por vídeo.",
    href: "/tratamentos/avaliacao-360/",
  },
];

export function ConsultaOnline() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-consulta">
      <section className="hero">
        <div className="container hero-inner">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span>
            <span>Contato</span> <span aria-hidden="true">›</span> <span>Consulta online</span>
          </nav>
          <p className="hero-sobretitulo">TELECONSULTA</p>
          <h1>
            Consulta online,
            <br />
            <em>para todo o Brasil</em>.
          </h1>
          <p className="hero-chamada">
            A mesma avaliação completa, por vídeo: história, sintomas, hábitos e exames, com
            acompanhamento contínuo a distância.
          </p>
          <a className="btn-ouro hero-btn" href={agendar}>
            Agendar teleconsulta
          </a>
        </div>
      </section>

      <section className="como-funciona">
        <div className="container">
          <div className="secao-titulo">
            <p className="sobretitulo">COMO FUNCIONA</p>
            <h2>Simples como uma chamada de vídeo</h2>
          </div>
          <ol className="passos">
            {PASSOS.map((p) => (
              <li className="passo" key={p.numero}>
                <span className="passo-numero">{p.numero}</span>
                <h3>{p.titulo}</h3>
                <p>{p.texto}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="frentes">
        <div className="container frentes-inner">
          <p className="sobretitulo">O QUE DÁ PARA TRATAR ONLINE</p>
          <h2>As mesmas frentes de tratamento, por vídeo</h2>
          <p className="frentes-chamada">
            A teleconsulta cobre avaliação e acompanhamento em todas as frentes do consultório.
            Quando for preciso exame físico, indicamos a presencial.
          </p>

          <ul className="frentes-grade">
            {FRENTES.map((f) => (
              <li className="card-frente" key={f.href}>
                <h3>{f.titulo}</h3>
                <p>{f.texto}</p>
                <a href={f.href}>Ver tratamento →</a>
              </li>
            ))}
          </ul>

          <a className="btn-ouro frentes-btn" href={agendar}>
            Agendar teleconsulta
          </a>
        </div>
      </section>
    </div>
  );
}
